'use strict';

class BasePresenter {
  constructor(options, templateName) {
    this.module = 'booking';
    this.options = options || {};
    this.templateName = templateName;
    this.model = this.model || this.options.model;
    this.collection = this.collection || this.options.collection;
    this.localesBasePath = `modules.${this.module}.${this.templateName}`;
  }

  setModule(module) {
    this.module = module;
    this.localesBasePath = `modules.${this.module}.${this.templateName}`;
  }

  toHash() {
    return;
  }

  getI18n(scope = this.localesBasePath) {
    return scope != null ? I18n.scoped(scope) : I18n;
  }

  toHashWithHelpers() {
    return I18n.mixin(this.toHash(), this.getI18n());
  }

  generateLink(i18nKey, href) {
    const label = this.getI18n().t(i18nKey);
    return `<a href='${href}'>${label}</a>`;
  }
}

module.exports = BasePresenter;
